export default __webpack_public_path__ + "static/media/iracing.a1c4ddb4.png";